export default __webpack_public_path__ + "static/media/861.182cd26e.png";